const INTERNAL_PATHS = {
  login:             '/',
  resetPassword:     '/reset-password',
  cardsInfo:         '/cards',
  orderCards:        '/cards/order',
  massActivateCards: '/cards/activate',
  reports:           '/reports',
  logout:            '/logout',
};
export default INTERNAL_PATHS;

/**
 * Paths without authorization. Tn other words: paths which don't
 * require the user to be logged in.
 */
const PATHS_WO_AUTHORIZATION = [
  INTERNAL_PATHS.login,
  INTERNAL_PATHS.resetPassword,
  INTERNAL_PATHS.logout
];
export { PATHS_WO_AUTHORIZATION }
